import { useEffect } from "react";
import { withRouter } from 'react-router-dom';


const PageScrollTop: React.FC<any> = (props) => {
    useEffect(() => {
        if (!props.location.hash) {
            window.scrollTo(0, 0);
        }
    }, [props.location]);
    return props.children;
};
export default withRouter(PageScrollTop);